class employeeMapper {
	toDomain(persistence) {
		const { name, ...rest } = persistence
		return {
			...rest,
			value: name,
		}
	}
}

export default new employeeMapper()
